<script lang="ts">
  import ShareButton from "./ShareButton.svelte";
  import Icon from "../Icon.svelte";

  export let url: string;
  let href: any;
  $: href = encodeURI(url);

</script>

<ShareButton {href}>
  <Icon width="32" height="32" type="SocialCircle" />
</ShareButton>
